<template>
	<div class="redictPage-body">
		页面加载中,请稍等...
	</div>
</template>

<script>
export default {
	name: 'redictPage',
	data () {
		return {
			router: '',
			app: '',
			query: ''
		}
	},
	created () {
		let token = this.$route.query.token
		this.router = this.$route.query.router
		this.app = this.$route.query.app
		this.query = decodeURIComponent(this.$route.query.query) || {}
		if (this.$route.query && this.$route.query.reportThroughPath) {
			this.query.throughParams = this.$route.query.reportThroughPath
		}
		window.sessionStorage.setItem('app', this.app)
		this.getsession(token)
	},
	methods: {
		getsession (token) {
			let params = {
				token: token
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlNVA}/scm8/login`,
				data: params
			}).then(res => {
				if (res.msg) {
					this.$message.error(res.msg)
					return false
				}
				window.sessionStorage.setItem('shiroSession', res.shiroSession)
				window.sessionStorage.setItem('entid', res.entid)
				setTimeout(() => {
					if (this.query && this.query !== '' && !this.$fxUtils.isEmptyObjSHW(this.query)) {
						this.$router.push({ path: this.router, query: this.query })
					} else {
						this.$router.push(this.router)
					}
				}, 1000)
			})
		}
	}
}

</script>

<style lang="stylus" scoped>
.redictPage-body{
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size:30px
}
</style>
<style lang="stylus">

</style>
